"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCompositionForcedReadOnly = exports.setCompositionSaveStatus = exports.setCompositionId = exports.updateCompositionFromUpdate = exports.saveComposition = exports.saveCompositionPending = exports.hideCompositionSaveFailedModal = exports.updateSummaryToSave = exports.updateTitleToSave = exports.updateContentToSave = exports.setInitialSummary = exports.setInitialTitle = exports.setInitialBodyContent = exports.fetchFullComposition = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var _convertImageEntitiesToBlockData = _interopRequireDefault(require("composer-lib/lib/convertImageEntitiesToBlockData"));

var _sessionManagersHelpers = require("composer-lib/lib/helpers/sessionManagersHelpers");

var getCompositionManager = function getCompositionManager(session) {
  return (0, _sessionManagersHelpers.getManagerWithSession)('composition', session);
};

var REALTIME_UPDATE_TRANSITION_TIME = 1250;
var fetchCompositionPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_COMPOSITION_PENDING);
var fetchCompositionFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_COMPOSITION_FAILED);
var fetchFullCompositionSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_FULL_COMPOSITION_SUCCEEDED);

var fetchFullComposition = function fetchFullComposition(id, session) {
  return function (dispatch) {
    var compositionManager = getCompositionManager(session);
    dispatch(fetchCompositionPending());
    compositionManager.fetchFullComposition(id).then(function (post) {
      return dispatch(fetchFullCompositionSucceeded(post));
    }, function (post) {
      return dispatch(fetchCompositionFailed(post));
    });
  };
};

exports.fetchFullComposition = fetchFullComposition;
var saveCompositionPendingCa = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMPOSITION_PENDING);
var saveCompositionSucceeded = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMPOSITION_SUCCEEDED);
var saveCompositionFailed = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMPOSITION_FAILED);
var saveCompositionFailedBecauseOfLock = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMPOSITION_FAILED_BECAUSE_OF_LOCK);
var saveCompositionFailedBecauseOfScope = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMPOSITION_FAILED_BECAUSE_OF_SCOPE);

var setInitialBodyContent = function setInitialBodyContent(content) {
  var convertedContent = (0, _convertImageEntitiesToBlockData.default)(content);
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.SET_INITIAL_CONTENT)(convertedContent));
  };
};

exports.setInitialBodyContent = setInitialBodyContent;

var setInitialTitle = function setInitialTitle(title) {
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.SET_INITIAL_TITLE)(title));
  };
};

exports.setInitialTitle = setInitialTitle;

var setInitialSummary = function setInitialSummary(summary) {
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.SET_INITIAL_SUMMARY)(summary));
  };
};

exports.setInitialSummary = setInitialSummary;

var updateContentToSave = function updateContentToSave(content) {
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.SAVE_NEW_CONTENT)(content));
  };
};

exports.updateContentToSave = updateContentToSave;

var updateTitleToSave = function updateTitleToSave(title) {
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.SAVE_NEW_TITLE)(title));
  };
};

exports.updateTitleToSave = updateTitleToSave;

var updateSummaryToSave = function updateSummaryToSave(summary) {
  return function (dispatch) {
    return dispatch((0, _utils.createAction)(_ActionTypes.default.SAVE_NEW_SUMMARY)(summary));
  };
};

exports.updateSummaryToSave = updateSummaryToSave;

var handleStandardLock = function handleStandardLock(dispatch) {
  return function (resp) {
    switch (resp.status) {
      case 412:
        return dispatch(saveCompositionFailedBecauseOfLock(resp));

      case 403:
        return dispatch(saveCompositionFailedBecauseOfScope(resp));

      default:
        return dispatch(saveCompositionFailed(resp));
    }
  };
};

var hideCompositionSaveFailedModal = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMPOSITION_FAILED_DISMISSED);
exports.hideCompositionSaveFailedModal = hideCompositionSaveFailedModal;

var saveCompositionPending = function saveCompositionPending() {
  return function (dispatch) {
    dispatch(saveCompositionPendingCa());
  };
};

exports.saveCompositionPending = saveCompositionPending;

var saveComposition = function saveComposition(post) {
  return function (dispatch) {
    dispatch(saveCompositionPendingCa());
    return getCompositionManager().updateComposition(post).then(function (resp) {
      return dispatch(saveCompositionSucceeded(resp));
    }, handleStandardLock(dispatch));
  };
};

exports.saveComposition = saveComposition;

var updateCompositionFromUpdate = function updateCompositionFromUpdate(data, userId) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REALTIME_UPDATE_COMPOSITION)({
      data: data,
      userId: userId
    }));
    setTimeout(function () {
      dispatch((0, _utils.createAction)(_ActionTypes.default.END_REALTIME_UPDATE_TRANSITION)());
    }, REALTIME_UPDATE_TRANSITION_TIME);
  };
};

exports.updateCompositionFromUpdate = updateCompositionFromUpdate;

var setCompositionId = function setCompositionId(id) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.SET_COMPOSER_COMPOSITION_ID)(id));
  };
};

exports.setCompositionId = setCompositionId;

var setCompositionSaveStatus = function setCompositionSaveStatus(status) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.SET_COMPOSITION_SAVE_STATUS)(status));
  };
};

exports.setCompositionSaveStatus = setCompositionSaveStatus;

var setCompositionForcedReadOnly = function setCompositionForcedReadOnly(readOnly) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.SET_COMPOSITION_FORCED_READ_ONLY)(readOnly));
  };
};

exports.setCompositionForcedReadOnly = setCompositionForcedReadOnly;